"use client";

import dynamic from "next/dynamic";
import type { ResizablePanelsProps } from "./ResizablePanels";

// Dynamic wrapper (SSR-safe)
const ResizablePanels = dynamic(() => import("./ResizablePanels").then((mod) => ({ default: mod.ResizablePanels })), {
  ssr: false,
  loading: () => <div className="h-full w-full animate-pulse bg-gray-200" />,
});

export { ResizablePanels };
export type { ResizablePanelsProps };
